import CampaignCustomFieldResourceListResultModel from '../../generated/types/model/resource/CampaignCustomFieldResourceListResultModel';

export default class CampaignCustomFieldResourceListResultViewModel extends CampaignCustomFieldResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
